import React, { useRef } from 'react';
import ContactForm from '../ContactForm'; // Make sure this component has the `openForm` method.
import logoSrc from '../img/logo.png'; // Assuming logo.png is in the img folder


function WebDevelopment() {
  const contactFormRef = useRef(); // Reference for controlling the contact form

  // Function to open the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };



  return (
    <>
    
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          {/* Left Side Content */}
          <div className="banner-text">
            <h1 className="banner-title">we code, custom needs</h1>
            <p className="banner-description">
              Craft seamless and high-performing web solutions with Shigjeta’s web development expertise. From responsive websites to custom integrations, we ensure your brand stands out online.
            </p>
            <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>


          </div>
          {/* Background Image */}
          
        </div>
      </section>
      <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/Main Services Thumbnail.png"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
              alt="img"
            />
      </div>

      {/* Custom Web Development Section */}
      <section className="about-section">
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Custom Web Development</strong></h2>
            <p>
              Build dynamic, scalable, and visually stunning websites tailored to meet your unique business needs.
            </p>
            <ul>
              <p><strong>Responsive Design:</strong> Optimized for all devices.</p>
              <p><strong>Performance:</strong> Fast load times and SEO-ready architecture.</p>
              <p><strong>Custom Features:</strong> Tailored functionality for your goals.</p>
              <p><strong>CMS Integration:</strong> Seamless content management systems.</p>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/m3.1.png" alt="Custom Web Development" />
          </div>
        </div>

        {/* Frontend Development Section */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Frontend Development</strong></h2>
            <p>
              Modern and interactive interfaces that enhance user experience and engagement.
            </p>
            <ul>
              <p><strong>HTML, CSS, JavaScript:</strong> Clean and optimized code.</p>
              <p><strong>Frameworks:</strong> Expertise in React, Vue, and Angular.</p>
              <p><strong>Interactive UI:</strong> Engaging, user-friendly experiences.</p>
              <p><strong>Animations:</strong> Smooth transitions and effects.</p>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/m3.2.png" alt="Frontend Development" />
          </div>
        </div>

        {/* Backend Development Section */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Backend Development</strong></h2>
            <p>
              Robust backend solutions that ensure performance, security, and scalability for your web applications.
            </p>
            <ul>
              <p><strong>API Development:</strong> Custom APIs for seamless integrations.</p>
              <p><strong>Databases:</strong> Scalable SQL and NoSQL solutions.</p>
              <p><strong>Server Management:</strong> Optimized for speed and security.</p>
              <p><strong>Languages:</strong> Proficiency in Node.js, PHP, and Laravel.</p>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/m3.3.png" alt="Backend Development" />
          </div>
        </div>

        {/* Web Optimization Section */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Web Optimization</strong></h2>
            <p>
              Improve site performance, speed, and SEO rankings with our optimization expertise.
            </p>
            <ul>
              <p><strong>Speed Optimization:</strong> Faster load times for better UX.</p>
              <p><strong>SEO-Friendly:</strong> Optimized for search engines.</p>
              <p><strong>Code Cleanup:</strong> Minimized and well-structured code.</p>
              <p><strong>Accessibility:</strong> Standards-compliant websites.</p>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/m3.4.png" alt="Web Optimization" />
          </div>
        </div>

        {/* Success Stories Section */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Success Stories</strong></h2>
            <p>
              Discover how our web development services have transformed businesses through impactful digital solutions.
            </p>
            <a href="/blog" className="cta-button">Read Case Studies</a>
          </div>
          <div className="about-image">
            <img src="/img/m3.5.png" alt="Web Development Success Stories" />
          </div>
        </div>
      </section>
      
  <ContactForm ref={contactFormRef} />
    </>
  );
}

export default WebDevelopment;
